export const webdatetime = () => {
        // const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
        // return time.toLocaleString("en-US", { hour: "numeric", minute: "numeric", hour12: true });
        const nD = new Date();
        const timelocal = nD.getFullYear()+"-"+("0" + (nD.getMonth() + 1)).slice(-2) +"-"+("0" + nD.getDate()).slice(-2)+" "+("0" + nD.getHours()).slice(-2)+":"+("0" + nD.getMinutes()).slice(-2)+":"+nD.getSeconds()
        return timelocal
}